import { on, reducer } from 'ts-action';
import { FilterQuery } from '../types/annotation-task-detail.type';
import * as adminActions from '../actions/admin.actions';
import { MenuSearchBoxOption } from '@cdl/heartbeat-react';
import {
  AnnotationTask,
  Annotator,
} from '../../ecg/types/annotation-tasks.type';

declare module 'react-redux' {
  interface DefaultRootState {
    admin: AdminState;
  }
}
export interface AdminState {
  activeAnnotationTasks: AnnotationTask[];
  inactiveAnnotationTasks: AnnotationTask[];
  activeTasksPage: number;
  inactiveTasksPage: number;
  searchParams: FilterQuery;
  annotatorsList: Annotator[];
  annotationGridsList: MenuSearchBoxOption[];
  isLoading: boolean;
}

const initialStateFactory = (): AdminState => {
  const searchParams = new URLSearchParams(window.location.search);

  return {
    activeAnnotationTasks: [],
    inactiveAnnotationTasks: [],
    activeTasksPage: 1,
    inactiveTasksPage: 1,
    searchParams: {
      status: searchParams.get('status') || '',
      startDate: searchParams.get('startDate') || '',
      endDate: searchParams.get('endDate') || '',
      searchInput: searchParams.get('searchInput') || '',
      selectedAnnotators: searchParams.getAll('selectedAnnotators') || [],
      selectedGrids: searchParams.getAll('selectedGrids') || [],
      selectedEfforts: searchParams.getAll('selectedEfforts') || [],
    },
    annotatorsList: [],
    annotationGridsList: [],
    isLoading: false,
  };
};

export default reducer(
  initialStateFactory(),
  on(
    adminActions.loadActive,
    (state, { activeAnnotationTasks, currentPage }): AdminState => {
      return {
        ...state,
        activeAnnotationTasks:
          currentPage === 1
            ? activeAnnotationTasks
            : [...state.activeAnnotationTasks, ...activeAnnotationTasks],
      };
    },
  ),
  on(
    adminActions.loadInactive,
    (state, { inactiveAnnotationTasks, currentPage }): AdminState => {
      return {
        ...state,
        inactiveAnnotationTasks:
          currentPage === 1
            ? inactiveAnnotationTasks
            : [...state.inactiveAnnotationTasks, ...inactiveAnnotationTasks],
      };
    },
  ),
  on(adminActions.setActiveTasksPage, (state, { page }): AdminState => {
    return {
      ...state,
      activeTasksPage: page,
    };
  }),
  on(adminActions.setInactiveTasksPage, (state, { page }): AdminState => {
    return {
      ...state,
      inactiveTasksPage: page,
    };
  }),
  on(adminActions.handleParams, (state, { param, value }): AdminState => {
    return {
      ...state,
      searchParams: {
        ...state.searchParams,
        [param]: value,
      },
    };
  }),
  on(adminActions.update, (state, { annotationTask, status }): AdminState => {
    const updatedAnnotationTask = { ...annotationTask, status };

    return {
      ...state,
      activeAnnotationTasks:
        status === 'ongoing'
          ? [updatedAnnotationTask, ...state.activeAnnotationTasks]
          : state.activeAnnotationTasks.filter(
              (item) => item.id !== annotationTask.id,
            ),
      inactiveAnnotationTasks:
        status !== 'ongoing' && annotationTask.status !== 'ongoing'
          ? [
              updatedAnnotationTask,
              ...state.inactiveAnnotationTasks.filter(
                (item) => item.id !== annotationTask.id,
              ),
            ]
          : status === 'paused' || status === 'archived'
          ? [updatedAnnotationTask, ...state.inactiveAnnotationTasks]
          : state.inactiveAnnotationTasks.filter(
              (item) => item.id !== annotationTask.id,
            ),
    };
  }),
  on(
    adminActions.setAnnotatorsList,
    (state, { annotatorsList }): AdminState => {
      return {
        ...state,
        annotatorsList: annotatorsList,
      };
    },
  ),
  on(
    adminActions.setAnnotationGridsList,
    (state, { annotationGridsList }): AdminState => {
      return {
        ...state,
        annotationGridsList: annotationGridsList,
      };
    },
  ),
  on(adminActions.setIsLoading, (state, { isLoading }): AdminState => {
    return {
      ...state,
      isLoading: isLoading,
    };
  }),
  on(
    adminActions.addNewTask,
    (state, { newtask }): AdminState => ({
      ...state,
      activeAnnotationTasks: [newtask, ...state.activeAnnotationTasks],
    }),
  ),
);
